<template>
  <div class="sub-header" :style="[{ '--backgroundColor': headerBackground }]">
    <router-link to="/">
      <img :src="storeLogo" alt="" class="logo" @click="gotoStore" />
    </router-link>
    <i
      class="el-icon-arrow-up down-icon"
      v-if="dropIconStatus"
      @click="openMenu"
    ></i>
    <i class="el-icon-arrow-down down-icon" @click="openMenu" v-else></i>
    <el-drawer
      :visible.sync="dropIconStatus"
      :with-header="false"
      :append-to-body="true"
      :class="['menu-card', { 'scroll-top': showSubTitle }]"
      :modal="false"
      direction="ttb"
      size="100%"
    >
      <el-menu :default-active="activeIndex" class="menu" mode="horizontal">
        <el-menu-item
          :index="item.value"
          v-for="item in menuList"
          :key="item.value"
          @click="onClick(item)"
        >
          <div class="text">{{ item.name }}</div>
          <div v-if="item.value === '3'" class="badge"></div>
        </el-menu-item>
      </el-menu>
      <!-- <el-button class="sign-up" @click="onClickSignup">
        {{ $t("mainpage.signupBtn") }}</el-button
      >
      <el-button class="login" @click="onClickLogin">
        {{ $t("mainpage.loginBtn") }}</el-button
      > -->
    </el-drawer>
    <el-menu :default-active="activeIndex" class="menu-nav" mode="horizontal">
      <el-menu-item
        :index="item.value"
        v-for="item in menuList"
        :key="item.value"
        @click="onClick(item)"
        class="item-text"
      >
        <div class="text">{{ item.name }}</div>
        <div v-if="item.value === '3'" class="badge"></div>
      </el-menu-item>
    </el-menu>
    <div class="right-btn">
      <!--      <div v-if="userMsg" class="dashbord" @click="gotoDashboard">-->
      <!--        <div>Dashboard</div>-->
      <!--      </div>-->
      <!-- <template v-if="!userMsg"> -->
      <template>
        <div class="mobile-login signup-btn" @click="onClickSignup">
          <div class="text-box">{{ $t("home.signupBtn") }}</div>
        </div>
        <div class="login-btn mobile-login" @click="onClickLogin">
          <div>{{ $t("home.loginBtn") }}</div>
        </div>
      </template>
    </div>
    <!-- <div class="btn" v-if="!userMsg"> -->
    <div class="btn">
      <div class="signup-btn" @click="onClickSignup">
        <div class="text-box">{{ $t("home.signupBtn") }}</div>
      </div>
      <div class="login-btn" @click="onClickLogin">
        <div>{{ $t("home.loginBtn") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import resetUrl from "../utils/resetUrl";
import { TRACKER_LOGIN_QUERY_STR } from "@/constant";

export default {
  props: {
    closeMenu: {
      type: Boolean,
    },
  },
  data() {
    return {
      activeIndex: "",
      menuList: [
        {
          name: "Gallery",
          link: "/gallery",
          value: "0",
        },
        // {
        //   name: "Pricing",
        //   link: "/pricing",
        //   value: '1',
        // },
        {
          name: "Templates",
          link: "/templates",
          value: "2",
        },
        // {
        //   name: "Store x Printerous",
        //   link: "/storePrinterous",
        //   value: "3",
        // },
      ],
      dropIconStatus: false,
      userMsg: null,
      url: process.env.VUE_APP_BASE_URL,
      showSubTitle: false,
      storeLogo: `${process.env.VUE_APP_STORE_OSS_URL}/home/storelogo.svg`,
      headerBackground: "#effaff",
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    trackParams() {
      return this.$store.state.trackParams;
    },
  },
  methods: {
    openMenu() {
      this.dropIconStatus = !this.dropIconStatus;
    },
    onClick(path) {
      if (this.$route.path !== path.link) {
        // if (path.value === 1 || path.value === 2) {
        //   window.open(`${path.link}`);
        // } else {
        this.$router.push(path.link);
        // }
        this.$logEvent("ds-s:click web nav menu", {
          button: path.name,
        });
        this.dropIconStatus = false;
      }
    },
    // 根据路由设置datatracking的值
    getSourceByRoute(route) {
      let source = "homepage";
      switch (route) {
        case "/gallery":
          source = "gallery";
          break;
        case "/pricing":
          source = "pricing";
          break;
        case "/templates":
          source = "templates";
          break;
        case "/storePrinterous":
          source = "store x printerous";
          break;
      }
      return source;
    },
    onClickLogin() {
      this.$store.commit("setPreRouter", this.$route.path);
      this.$logEvent("ds-s:click web login button", {
        source: this.getSourceByRoute(this.$route.path),
      });
      window.open(
        resetUrl(
          `${process.env.VUE_APP_BASE_URL}/common/login?${TRACKER_LOGIN_QUERY_STR}`,
          this.trackParams
        )
        // "_self"
      );
    },
    onClickSignup() {
      this.$store.commit("setPreRouter", this.$route.path);
      this.$logEvent("ds-s:click web register button", {
        source: this.getSourceByRoute(this.$route.path),
      });
      window.open(
        resetUrl(
          `${process.env.VUE_APP_BASE_URL}/common/signup?${TRACKER_LOGIN_QUERY_STR}`,
          this.trackParams
        )
        // "_self"
      );
    },
    gotoDashboard() {
      window.open(
        resetUrl(
          `${process.env.VUE_APP_BASE_URL}/store/dashboard`,
          this.trackParams
        )
        // "_self"
      );
    },
    watchScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop >= 60) {
        this.showSubTitle = true;
      } else {
        this.showSubTitle = false;
      }
    },
    gotoStore() {
      this.dropIconStatus = false;
    },
  },
  async mounted() {
    this.$i18n.locale = this.$store.state.language;
    if (
      JSON.parse(localStorage.getItem("storeHomeVuex")) &&
      JSON.parse(localStorage.getItem("storeHomeVuex")).userInfo
    ) {
      this.$store.commit(
        "setUserInfo",
        JSON.parse(localStorage.getItem("storeHomeVuex")).userInfo
      );
    }
    window.addEventListener("scroll", this.watchScroll);
  },
  watch: {
    userInfo: {
      handler(val) {
        if (val) {
          this.userMsg = val;
        } else {
          this.userMsg = JSON.parse(
            localStorage.getItem("storeHomeVuex")
          ).userInfo;
        }
      },
    },
    closeMenu: {
      handler(val) {
        if (val === true) {
          this.dropIconStatus = false;
        }
      },
      immediate: true,
    },
    $route: {
      handler(val) {
        if (val.name === "Gallery") {
          this.activeIndex = "0";
          this.headerBackground = "#effaff";
        } else if (val.name === "StorePrinterous") {
          this.headerBackground = "#ccefff";
          this.activeIndex = "3";
        } else if (val.name === "Templates") {
          this.headerBackground = "#ccefff";
          this.activeIndex = "2";
        } else {
          this.headerBackground = "#effaff";
          this.activeIndex = "";
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="less" scoped>
.menu-card {
  width: 100%;
  position: fixed;
  left: 0 !important;
  top: 143px;
  border: none;
  border-radius: 0;
  height: 212px;
  /deep/.el-drawer {
    background: transparent;
  }
  /deep/.el-drawer__body {
    height: 100%;
    width: 100%;
    background: rgba(239, 250, 255, 0.9);
    backdrop-filter: blur(10px);
    .sign-up {
      width: calc(100% - 40px);
      margin: 62px 20px 20px;
      font-family: @font-family-regular;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 20px;
      letter-spacing: -0.02em;
      color: #2e4399;
      border: none;
      border-radius: 6px;
      padding: 10px;
      box-sizing: border-box;
    }
    .login {
      background: none;
      width: calc(100% - 40px);
      margin: 0 20px;
      font-family: @font-family-regular;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 20px;
      letter-spacing: -0.02em;
      color: #ffffff;
      border: 2px solid #ffffff;
      filter: drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.05));
      border-radius: 6px;
    }
    .menu {
      display: flex;
      flex-direction: column;
      background: none;
      border-bottom: none;
      .el-menu-item {
        color: #000000;
        font-family: @font-family-regular;
        font-style: normal;
        font-weight: normal;
        font-size: 20px;
        line-height: 20px;
        letter-spacing: -0.02em;
        border-bottom: none;
        display: flex;
        flex-direction: row;
        align-items: center;
        width: min-content;
        background-color: transparent;
        .text {
          opacity: 0.5;
          position: relative;
        }
      }
      .el-menu-item {
        height: 48px !important;
      }
      .el-menu-item.is-active {
        // text-decoration-line: underline;
        // background: none;
      }
      .el-menu-item.is-active .text::after {
        width: 100%;
      }
      .el-menu-item:hover {
        // text-decoration-line: underline;
        background: none;
        .text {
          opacity: 1;
        }
      }
      .text::after {
        content: "";
        display: block;
        /*开始时候下划线的宽度为0*/
        width: 0;
        height: 1px;
        position: absolute;
        left: 0;
        bottom: -10px;
        background: #000;
        /*这里我们设定所有改变都有动画效果，可以自己指定样式才有动画效果*/
        transition: all 0.3s ease-in-out;
      }
      .el-menu-item:hover .text::after {
        width: 100%;
      }
    }
  }
}
.scroll-top {
  top: 76px;
}
.badge {
  background: #2e4399;
  border-radius: 36px;
  width: 16px;
  height: 16px;
  margin-top: -10px;
  margin-left: 3px;
}
.sub-header {
  // background: rgba(11, 29, 131, 0.9);
  // backdrop-filter: blur(12px);
  background: var(--backgroundColor);
  padding: 30px 106px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  // align-items: center;
  //position: relative;
  top: 101px;
  position: fixed;
  z-index: 12;
  margin-top: 0;
  width: 100%;
  transition: all 1s cubic-bezier(0.1, 1, 0.2, 1);
  @media screen and (max-width: 1174px) {
    top: 68px;
  }
  .logo {
    width: 104px;
  }
  .down-icon {
    display: none;
  }
  .mobile-login {
    display: none;
  }
  .menu-nav {
    margin-left: 102px;
    border-bottom: none;
    background: none;
    .el-menu-item {
      font-family: @font-family-regular;
      font-style: normal;
      font-weight: normal;
      font-size: 18px;
      height: 49px;
      line-height: 18px;
      border-bottom: none;
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      padding-top: 9px;
      box-sizing: border-box;
      .text {
        color: rgba(0, 0, 0, 0.5);
        position: relative;
      }
    }
    .el-menu-item.is-active {
      // text-decoration-line: underline;
      background: none;
      color: #000;
      .text {
        opacity: 1;
        color: #000;
      }
    }
    .el-menu-item.is-active .text::after {
      width: 100%;
    }
    .el-menu-item:hover {
      // text-decoration-line: underline;
      color: #000;
      background: none;
      .text {
        opacity: 1;
        color: #000;
      }
    }
    .text::after {
      content: "";
      display: block;
      /*开始时候下划线的宽度为0*/
      width: 0;
      height: 1px;
      position: absolute;
      left: 0;
      bottom: -10px;
      background: #000;
      /*这里我们设定所有改变都有动画效果，可以自己指定样式才有动画效果*/
      transition: all 0.3s ease-in-out;
    }
    .el-menu-item:hover .text::after {
      width: 100%;
    }
  }
  .right-btn {
    position: absolute;
    right: 106px;
  }
  .dashbord {
    font-family: @font-family-regular;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 48px;
    width: 134px;
    color: #fff;
    letter-spacing: 0.02em;
    height: 48px;
    text-align: center;
    box-sizing: border-box;
    border-radius: 8px;
    background: @primary-color;
    text-decoration: none;
    position: relative;
    cursor: pointer;
  }
  .dashbord::after {
    content: "";
    display: block;
    width: 0;
    height: 100%;
    background: #006bd5;
    position: absolute;
    border-radius: 8px;
    left: 0;
    top: 0;
    z-index: -1;
    transition: 0.4s;
  }
  .dashbord:hover::after {
    width: 100%;
    z-index: 1;
    clear: both;
  }
  .dashbord:hover {
    color: #fff;
    div {
      z-index: 4;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
    }
  }

  .btn {
    position: absolute;
    right: 106px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .login-btn {
      margin-left: 12px;
      width: 134px;
      height: 48px;
      box-sizing: border-box;
      font-style: normal;
      font-weight: bold;
      font-size: 14px;
      line-height: 48px;
      background: @primary-color;
      letter-spacing: 0.02em;
      text-transform: uppercase;
      cursor: pointer;
      color: #ffffff;
      border-radius: 8px;
      text-align: center;
      position: relative;
      overflow: hidden;
    }
    .login-btn::after {
      content: "";
      display: block;
      width: 0;
      height: 100%;
      background: #006bd5;
      position: absolute;
      border-radius: 8px;
      left: 0;
      top: 0;
      z-index: -1;
      transition: 0.4s;
    }
    .login-btn:hover::after {
      width: 100%;
      z-index: 1;
      clear: both;
    }
    .login-btn:hover {
      color: #fff;
      div {
        z-index: 4;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
      }
    }
    .signup-btn {
      width: 134px;
      overflow: hidden;
      height: 48px;
      box-sizing: border-box;
      border-radius: 8px;
      font-style: normal;
      font-size: 14px;
      line-height: 44px;
      text-transform: uppercase;
      color: #2a95ff;
      cursor: pointer;
      text-align: center;
      position: relative;
      .text-box {
        width: 100%;
        height: 100%;
        border: 2px solid #2a95ff;
        box-sizing: border-box;
        overflow: hidden;
        border-radius: 8px;
        z-index: 2;
        background-color: transparent;
        position: absolute;
      }
    }
    .signup-btn::after {
      content: "";
      display: block;
      width: 0;
      height: 100%;
      background: #006bd5;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 0;
      transition: 0.3s;
    }
    .signup-btn:hover::after {
      width: 100%;
      clear: both;
    }
    .signup-btn:hover {
      color: #fff;
      .text-box {
        border: 2px solid #006bd5;
      }
    }
  }
  @media screen and (max-width: 1174px) {
    padding: 20px 15px;
    box-sizing: border-box;
    background: var(--backgroundColor);
    .logo {
      width: 95px;
    }
    .menu-nav {
      display: none;
    }
    .btn {
      display: none;
    }
    .down-icon {
      display: block;
      color: #4b5563;
      font-weight: bolder;
      margin-left: 24px;
      line-height: 36px;
    }
    .dashbord {
      right: 15px;
      height: 36px;
      box-sizing: border-box;
      font-size: 12px;
      line-height: 36px;
      width: 81px;
    }
    .mobile-login {
      display: block;
    }
    .right-btn {
      display: flex;
      position: absolute;
      right: 15px;
      .login-btn {
        margin-left: 6px;
        width: 81px;
        height: 36px;
        box-sizing: border-box;
        overflow: hidden;
        font-style: normal;
        font-weight: bold;
        font-size: 12px;
        line-height: 34px;
        background: @primary-color;
        letter-spacing: 0.02em;
        text-transform: uppercase;
        cursor: pointer;
        color: #ffffff;
        border-radius: 8px;
        text-align: center;
        position: relative;
      }
      .login-btn::after {
        content: "";
        display: block;
        width: 0;
        height: 100%;
        background: #006bd5;
        position: absolute;
        border-radius: 8px;
        left: 0;
        top: 0;
        z-index: -1;
        transition: 0.4s;
      }
      .login-btn:hover::after {
        width: 100%;
        z-index: 1;
        clear: both;
      }
      .login-btn:hover {
        color: #fff;
        div {
          z-index: 4;
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
        }
      }
      .signup-btn {
        width: 81px;
        height: 36px;
        box-sizing: border-box;
        border-radius: 8px;
        overflow: hidden;
        font-style: normal;
        font-weight: bold;
        font-size: 12px;
        line-height: 34px;
        letter-spacing: 0.02em;
        text-transform: uppercase;
        color: #2a95ff;
        cursor: pointer;
        text-align: center;
        position: relative;
        .text-box {
          width: 100%;
          height: 100%;
          border: 2px solid #2a95ff;
          box-sizing: border-box;
          overflow: hidden;
          border-radius: 8px;
          z-index: 2;
          background-color: transparent;
          position: absolute;
        }
      }
      .signup-btn::after {
        content: "";
        display: block;
        width: 0;
        height: 100%;
        background: #006bd5;
        position: absolute;
        left: 0;
        top: 0;
        z-index: -1;
        transition: 0.3s;
      }
      .signup-btn:hover::after {
        width: 100%;
        clear: both;
      }
      .signup-btn:hover {
        color: #fff;
        .text-box {
          border: 2px solid #006bd5;
        }
      }
    }
  }
}
</style>
